module.exports = __webpack_public_path__ + "media/images/pic/form_orange-d3136956f2caf171a64c105fee3283aa.svg";